<template>

  <div
    class="checkout-items"
    >
    <b-card
      class="private-1"
      no-body
    >
      <div class="item-img">
        <div class="item-name">
          <h6 class="mb-0">
            <b-link class="text-body">
              {{ product.name }}
            </b-link>
          </h6>
        </div>
      </div>

      <b-card-body class="card-private justify-content-center">
        <div class="item-quantity">
          <span class="quantity-title">Cantidad:</span>
          <b-form-spinbutton
            v-model="product.quantity"
            size="sm"
            :max="product.stock"
            class="ml-75"
            inline
          />
        </div>
      </b-card-body>
      <div class="item-options text-center">
        <div class="item-wrapper">
          <div class="item-cost">
            <p
              class="card-text shipping"
            >
              <b-badge
                pill
                variant="light-success"
              >
                {{ $t('pages.products.unitPrice') }}
              </b-badge>
            </p>
            <h4 class="item-price">
              {{ product.price }}  {{ divisa }}
            </h4>
          </div>
        </div>
        <b-button
          variant="danger"
          class="btn-cart move-cart"
        >
          <feather-icon
            icon="XIcon"
            class="mr-50"
          />
          <span>Remove</span>
        </b-button>
      </div>
    </b-card>
  </div>

</template>

<script>
import {
  BCard, BCardBody, BLink, BRow, BCol, BImg, BButton, BBadge, BFormSpinbutton, BPagination
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardBody,
    BLink,
    BImg,
    BButton,
    BBadge,
    BFormSpinbutton,
    BRow,
    BCol,
    BPagination
  },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      page: 1,
      totalProducts: 10,
      perPage: 5,
    }
  },
  setup() {
    
  },

  computed: {
    divisa() {
      return this.$store.state.appConfig.divisa || 'USD'
    }
  },
}
</script>

<style>

</style>
